module.exports = __webpack_public_path__ + "static/img/hscode.0a82b739.svg";